module.exports = __webpack_public_path__ + "img/LogFailLoadDBSystem.82edaa57.png";